module.exports = __webpack_public_path__ + "img/trash-can-clock.23077e40.svg";